import request from '@ps/utils/request'
import { ResponseData } from 'request'
import pathConfig from '@ps/bridge/path'

export interface AudioToProjectParams {
  pid: number
  asset_id: string // 因为资产库的id 超过了int的范围，所以这里用string
  path: string
  from: string // 1 公共资源库 2 新公共资源库 3 用户资源库
  path_origin: string // 只有从资产库中获取的音频才会有这个字段，记录这个音频的原始地址
}

// http://10.192.167.79:8067/?doc=playsmart/playturbo%2fhandler%2fplaysmart%2feditor_audio.go
export function addAudioToProject(data: Partial<AudioToProjectParams>) {
  if (Number(data.from) === 3 || Number(data.from) === 2) {
    data.path_origin = pathConfig.ORIGIN_RESOURCE_PATH
  }
  return request<
    ResponseData<{
      duration: number
      file_size: number
      md5: string
      path: string
    }>
  >({
    url: '/ps/editor/audio/add',
    method: 'post',
    data: {
      ...data,
      path: data.path || pathConfig.AUDIO_BASIC_PATH,
    },
  })
}

export function editAudioAndAddToProject(data: {
  pid: number
  url: string
  vol: number
  stime?: number
  etime?: number
  path?: string
}) {
  return request({
    url: '/ps/editor/audio/edit',
    method: 'post',
    data: {
      ...data,
      path: data.path || pathConfig.AUDIO_BASIC_PATH,
    },
  })
}
